/** @format */

//Notitications
export const notiticationsData = [
  {
    id: 1,
    image: "3.jpg",
    color: "danger",
    icon: "heart",
    name: "Emay Walter",
    text: "liked your post",
    time: "10 minutes ago",
  },
  {
    id: 2,
    image: "4.jpg",
    color: "info",
    icon: "share-alt",
    name: "Allie Grater",
    text: "shared your post",
    time: "5 hours ago",
  },
  {
    id: 3,
    image: "7.jpg",
    color: "success",
    icon: "wechat",
    name: "Colin Sik",
    text: "commented on your post",
    time: "yesterday",
  },
];

//ChatHeader
export const chatHeaderData = [
  {
    id: 1,
    image: "1.jpg",
    text: "Hello.how are you?",
  },
  {
    id: 2,
    image: "3.jpg",
    text: "Hi, i'm fine.what about you?",
  },
  {
    id: 3,
    image: "1.jpg",
    text: "I am facing js issue can you help me?",
  },
  {
    id: 4,
    image: "3.jpg",
    text: "Sure, i will help you.",
  },
];

//CartHeader
export const cartHeaderData = [
  {
    id: 1,
    image: "img2.jpg",
    name: "Beauty cosmetic",
    price: 20,
    quantity: 2,
  },
  {
    id: 2,
    image: "img-1.jpg",
    name: "Simple shoes",
    price: 30,
    quantity: 1,
  },
];

//Profile
export const SettingsData = [
  // {
  //   id: 1,
  //   link: `sign_up`,
  //   icon: "user",
  //   text: "Account",
  // },
  // {
  //     id: 2,
  //     link: `applications/email/letter_box`,
  //     icon: 'stroke-email',
  //     text: 'Inbox'
  // },
  // {
  //   id: 1,
  //   link: `employees`,
  //   icon: "user",
  //   text: "Employees",
  // },
  {
    id: 2,
    link: `products`,
    icon: "product-detail",
    text: "Products",
  },
  {
    id: 27,
    link: `categories`,
    icon: "categories",
    text: "Categories",
  },
  {
    id: 29,
    link: `orders`,
    icon: "orders",
    text: "Orders",
  },
  {
    id: 12,
    link: `addons`,
    icon: "product-category",
    text: "Addons",
  },

  {
    id: 16,
    link: `discounts`,
    icon: "sales",
    text: "Discounts",
  },
  {
    id: 17,
    link: `event-discounts`,
    icon: "calendar",
    text: "Event Discounts",
  },
  {
    id: 4,
    link: `payment-types`,
    icon: "notepad",
    text: "Pay Types",
  },

  {
    id: 44,
    link: `shortcode`,
    icon: "status-up",
    text: "Shortcode",
  },
  // {
  //   id: 4,
  //   link: `edit-profile`,
  //   icon: "settings",
  //   text: "Settings",
  // },
];

//Profile
export const profileHeaderData = [
  // {
  //   id: 1,
  //   link: `sign_up`,
  //   icon: "user",
  //   text: "Account",
  // },
  // {
  //     id: 2,
  //     link: `applications/email/letter_box`,
  //     icon: 'stroke-email',
  //     text: 'Inbox'
  // },
  // {
  //   id: 1,
  //   link: `employees`,
  //   icon: "user",
  //   text: "Employees",
  // },
  {
    id: 1,
    link: `settings`,
    icon: "settings",
    text: "Settings",
  },
  {
    id: 11,
    link: `registers`,
    icon: "settings",
    text: "Close Register",
  },
  {
    id: 112,
    link: `end_day`,
    icon: "settings",
    text: "End Day",
  },
  {
    id: 113,
    link: `external_inventory`,
    icon: "settings",
    text: "External inventory",
  },
  // {
  //   id: 2,
  //   link: `products`,
  //   icon: "product-detail",
  //   text: "Products",
  // },
  // {
  //   id: 27,
  //   link: `categories`,
  //   icon: "categories",
  //   text: "Categories",
  // },

  // {
  //   id: 12,
  //   link: `addons`,
  //   icon: "product-category",
  //   text: "Addons",
  // },
  {
    id: 2,
    link: `reports`,
    icon: "stroke-charts",
    text: "Reports",
  },
  {
    id: 2,
    link: `printers`,
    icon: "print",
    text: "Printers",
  },
  {
    id: 3,
    link: `customers`,
    icon: "user",
    text: "Customers",
  },
  {
    id: 13,
    link: `cashiers`,
    icon: "stroke-user",
    text: "Cashier",
  },
  // {
  //   id: 16,
  //   link: `discounts`,
  //   icon: "stroke-coupon",
  //   text: "Discounts",
  // },
  // {
  //   id: 4,
  //   link: `payment-types`,
  //   icon: "notepad",
  //   text: "Pay Types",
  // },
  {
    id: 54,
    link: `set_register_amount`,
    icon: "book",
    text: "Set Register",
  },
  // {
  //   id: 44,
  //   link: `shortcode`,
  //   icon: "status-up",
  //   text: "Shortcode",
  // },
  // {
  //   id: 4,
  //   link: `edit-profile`,
  //   icon: "settings",
  //   text: "Settings",
  // },
];

export const languagesData = [
  {
    data: "en",
    language: "English",
  },
  {
    data: "du",
    language: "Deutsch",
  },
  {
    data: "es",
    language: "Español",
  },
  {
    data: "fr",
    language: "Français",
  },
  {
    data: "pt",
    language: "Português",
  },
  {
    data: "cn",
    language: "简体中文",
  },
  {
    data: "ae",
    language: "لعربية",
  },
];
